import { UseFormRegisterReturn } from 'react-hook-form';
import { Autocomplete, TextField } from '@mui/material';
import { InventoryAsset } from '../../../types';
import { formatLocation } from './serviceRequestModel';
import { InventoryFieldProps, inventoryLabel } from './inventoryField';

interface DisconnectFieldsProps extends InventoryFieldProps {
  selected: InventoryAsset[];
  onChange: (value: InventoryAsset[]) => void;
  detailsField: UseFormRegisterReturn;
}

/** The services a Disconnect takes down, and its details box. */
export function DisconnectFields({
  disabled,
  options,
  displayLocationCode,
  selected,
  onChange,
  detailsField
}: DisconnectFieldsProps) {
  return (
    <>
      <div style={{ breakInside: 'avoid', marginBottom: '1.5rem' }}>
        <Autocomplete
          multiple
          disabled={disabled}
          sx={{ width: '100%' }}
          size="small"
          options={options}
          value={selected}
          onChange={(_, newValue) => onChange(newValue)}
          getOptionLabel={(option: InventoryAsset) => {
            if (option === null) return '';
            return formatLocation(option, displayLocationCode);
          }}
          filterSelectedOptions
          renderInput={(params) => (
            <TextField
              {...params}
              label={inventoryLabel(displayLocationCode)}
              inputProps={{
                ...params.inputProps,
                required: selected.length === 0
              }}
            />
          )}
        />
      </div>
      <div style={{ breakInside: 'avoid', marginBottom: '1.5rem' }}>
        <TextField
          label="Disconnect Request Details"
          placeholder="ie: location closing"
          id="details_textarea"
          data-cy="details"
          aria-label="details"
          sx={{ width: '100%' }}
          disabled={disabled}
          minRows={3}
          multiline
          {...detailsField}></TextField>
      </div>
    </>
  );
}
